import Lozenge from '@atlaskit/lozenge';

export const formatDateTime = (value: string) =>
  new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(value));

export const renderCompletion = (value: boolean) => (
  <input
    type="checkbox"
    checked={value}
    readOnly
    aria-label={value ? 'Completed' : 'Not completed'}
    style={{
      accentColor: 'var(--ds-background-accent-green-bolder, #1f845a)',
      cursor: 'default',
      height: '16px',
      pointerEvents: 'none',
      width: '16px'
    }}
  />
);

export const renderStatus = (status: string) => {
  const appearance =
    status === 'Active' ? 'success' : status === 'Pending' ? 'inprogress' : 'default';

  return <Lozenge appearance={appearance}>{status}</Lozenge>;
};
